import {useEffect, useMemo, useState} from "react";
import Button from "../../components/Button/Button";
import {useNavigate} from "react-router-dom";
import Icon, {
    customerIcon,
    notSentIcon,
    plusIcon,
    returnedIcon,
    sentIcon,
    signedIcon
} from "../../components/Icon/Icon";
import Table from "../../components/Table/Table";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import "./Customers.scss"
import Actions from "../../components/Actions/Actions";
import {useNotification} from "../../hooks/useNotification";
import SendModal from "./SendModal";
import classNames from "classnames";
import PageLayout from "../../components/PageLayout/PageLayout";
import CustomerActions from "../../api/CustomerActions";

const statusIcon = {
    "NOT_SENT": notSentIcon,
    "SENT": sentIcon,
    "RETURNED": returnedIcon,
    "SAVED": signedIcon
}
const statusText = {
    "NOT_SENT": "Not sent",
    "SENT": "Sent",
    "RETURNED": "Returned",
    "SAVED": "Saved"
}

const Customers = () => {
    const navigate = useNavigate();
    const [customers, setCustomers] = useState([]);
    const [deleteModal, setDeleteModal] = useState(null);
    const [sendModal, setSendModal] = useState(null);
    const {triggerNotification} = useNotification();

    useEffect(() => {
        CustomerActions.loadCustomers(setCustomers);
    }, []);

    const columns = useMemo(() => [
        {
            accessorKey: 'name',
            header: 'Customer name',
            cell: ({row}) => {
                const {name, surname, customerForms} = row.original;

                return (
                    <>
                        <p>{name} {surname}</p>
                        {customerForms.map(form => (
                            <div className={classNames("form", {"returned": form.status==="RETURNED"}, {"sent": form.status==="SENT"})}>

                                <Icon svg={statusIcon[form.status]}/>

                                {form.form.name}

                                <div className="tooltip">
                                    <span className="triangle"></span>
                                    <div className="text">{statusText[form.status]}</div>
                                </div>
                            </div>
                        ))}
                    </>
                )
            }
        },
        {
            accessorKey: 'actions',
            header: 'Actions',
            cell: ({row}) => {
                const id = row.original.id;

                return (
                    <Actions
                        onEdit={() => navigate(`/customers/customer/${id}`)}
                        onDelete={() => setDeleteModal(row.original)}
                        onSend={() => setSendModal(id)}
                    />
                );
            }
        }
    ], [navigate]);

    return (
        <PageLayout
            titlePage="Customers"
            icon={customerIcon}
            actions={
                <Button className="add" onClick={() => navigate('/customers/customer')}>
                    <Icon svg={plusIcon}/>
                    Add New
                </Button>
            }
            className="customers"
        >
            <Table data={customers} columns={columns}></Table>

            {
                deleteModal &&
                <DeleteModal
                    onClose={() => setDeleteModal(null)}
                    onConfirm={() => CustomerActions.deleteCustomer(deleteModal.id, () => {
                        setCustomers(prevCustomer => prevCustomer.filter(customer => customer.id !== deleteModal.id));
                        setDeleteModal(null);
                        triggerNotification("Customer was deleted successfully")
                    })}
                    title="Deleting customer"
                    message={`Are you sure you want to delete customer "${deleteModal?.name} ${deleteModal?.surname || ''}"?`}
                />
            }
            {
                sendModal &&
                <SendModal
                    id={sendModal}
                    onClose={() => setSendModal(null)}
                    onSubmit={({customerId, sentForms}) => {
                        setCustomers(prevCustomer => prevCustomer.map(customer => {
                            if(customer.id === customerId){
                                return {
                                    ...customer,
                                    customerForms: customer.customerForms.map(customerForm => {
                                        if(sentForms.includes(customerForm.form.id)){
                                            return {
                                                ...customerForm,
                                                status: "SENT"
                                            }
                                        }

                                        return customerForm;
                                    })
                                }
                            }

                            return customer;
                        }));
                        setSendModal(null);
                        triggerNotification("Message was sent successfully");
                    }}
                />
            }
        </PageLayout>
    );
}

export default Customers;